import { Visibility } from "@material-ui/icons";
import React from "react";
import { useState } from "react";
import { transformUniversalDateToLocalDate } from "../../utils/dateUtils";
import "./Solicitud.scss";
import { useHistory } from "react-router-dom";
import RequestGradeCartButton from "../RequestGradeCartButton/RequestGradeCartButton";
import TurnRightIcon from "../../assets/icons/TurnRightIcon";
import TurnLeftIcon from "../../assets/icons/TurnLeftIcon";



export const Solicitud = ({ solicitud }) => {
    
    const [loadingIdentifier, setLoadingIdentifier] = useState(false);
    const history = useHistory();

    const openRequestDetail = identification => {
        history.push("/request/" + identification);
    }

    const [flipped, setFlipped] = useState("front");

    const flipCard = () => {
        setFlipped(flipped === "flipped" ? "" : "flipped");

    }


    return (
        <div className="background-card">
            <div className={`border rounded-2 
            shadow mb-5 card-solicitud ${flipped}`}>
                <div className="card-solicitud-flip">
                    <div className="card-solicitud-front">
                        <div className="card-solicitud-front-header bg-white pt-2 px-2 rounded-top">
                            <header>
                                <h2>{solicitud.debtor.identification}</h2>
                                <button
                                    onClick={flipCard}
                                >
                                    <TurnRightIcon
                                        className="nav-icon-button"
                                        width={22}
                                        heigth={22}
                                    ></TurnRightIcon>
                                </button>
                            </header>
                        </div>
                        <div className="card-solicitud-front-body text-start bg-white px-3 row mx-0">
                            <h3 className="text-start overflow-ellipsis">{solicitud.debtor.name}</h3>
                            <div className="estado col-6 px-0">
                                <div className={`${solicitud.status}`}></div>{solicitud.status === 'active' ? 'En vigor' : 'Expirado'}
                            </div>
                            <div className="see-detail col-6 pe-0 text-end"
                            key={solicitud.id}
                            onClick={() => openRequestDetail(solicitud.id)}>
                                <Visibility style={{ color: '#5c157d', width: "18px", marginInlineEnd: "5px", marginBottom: "2px" }} />
                          <span className="see-detail-btn">Ver detalle</span>
                            </div>
                        </div>
                        <div className="card-solicitud-front-footer bg-white pb-4 rounded-bottom">
                            <div className="container">
                                <div className="row">
                                    <div className="col-7">
                                        {solicitud.status === 'expired' ? (
                                            <span className="re-request"><RequestGradeCartButton company={solicitud} loadingIdentifier={loadingIdentifier} setLoadingIdentifier={setLoadingIdentifier} /></span>
                                        ) : null}
                                    </div>

                                    <div className="col-5 fecha">
                                        {transformUniversalDateToLocalDate(solicitud.gradeRequestDate)}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-solicitud-back">
                        <div className="card-solicitud-back-header bg-white rounded-top pb-2 pt-2">
                            <header>

                                <button className="close-button me-2"
                                    onClick={flipCard}>
                                    <TurnLeftIcon 
                                     width={22}
                                     heigth={22}/>
                                </button>
                                <h2 className="text-start bg-white p-2 ps-3 overflow-string">{solicitud.debtor.name}</h2>
                            </header>

                        </div>

                        <div className="card-solicitud-back-body bg-white rounded-bottom pb-4">

                            <div className={`grade grade-${solicitud.debtor.grade}`}>
                                {solicitud.debtor.grade}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
